<template>
  <aside class="app-sidebar">
    <div class="sidebar-brand">
      <div class="logo" aria-hidden="true">
        <svg viewBox="0 0 40 40" width="40" height="40">
          <rect width="40" height="40" rx="10" fill="#F5C518" />
          <ellipse cx="20" cy="22" rx="9" ry="11" fill="#2B2B2B" />
          <ellipse cx="20" cy="22" rx="6.5" ry="8.5" fill="#F5C518" />
          <path d="M13 16 Q20 10 27 16" fill="none" stroke="#2B2B2B" stroke-width="2.2" stroke-linecap="round" />
          <circle cx="16.5" cy="14" r="2.2" fill="#2B2B2B" />
          <circle cx="23.5" cy="14" r="2.2" fill="#2B2B2B" />
          <path d="M11 20 Q7 16 9 12" fill="none" stroke="#fff" stroke-width="1.6" opacity=".85" />
          <path d="M29 20 Q33 16 31 12" fill="none" stroke="#fff" stroke-width="1.6" opacity=".85" />
        </svg>
      </div>
      <div class="brand-text">
        <div class="brand-name">外勤蜂</div>
        <span class="brand-tag">客服工作台</span>
      </div>
    </div>

    <el-menu
      :default-active="activeMenu"
      :default-openeds="openedMenus"
      class="sidebar-menu"
      router
    >
      <el-menu-item
        v-for="item in menuItems"
        :key="item.path"
        :index="item.path"
      >
        <span class="menu-icon" aria-hidden="true">
          <i v-if="item.icon" :class="item.icon" />
          <svg
            v-else-if="item.svg === 'swap'"
            class="swap-icon"
            viewBox="0 0 24 24"
            width="18"
            height="18"
          >
            <path
              d="M4 9h12M12 5l4 4-4 4M20 15H8M12 11l-4 4 4 4"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-else-if="item.svg === 'worker'"
            class="worker-icon"
            viewBox="0 0 24 24"
            width="18"
            height="18"
          >
            <path d="M7 8.2h10" fill="none" stroke="#F5C518" stroke-width="3.2" stroke-linecap="round" />
            <path d="M8 8.2V6.4c0-1.4 1.8-2.6 4-2.6s4 1.2 4 2.6v1.8" fill="#F5C518" />
            <circle cx="12" cy="13" r="3.3" fill="#F4C7A8" />
            <path d="M8.2 16.2c.8-1 2.2-1.6 3.8-1.6s3 .6 3.8 1.6" fill="#3B82F6" />
            <path d="M7.6 16.8h8.8v3.6H7.6z" fill="#F97316" />
            <path d="M11.2 16.8h1.6v3.6h-1.6z" fill="#FB923C" />
          </svg>
        </span>
        <span class="menu-item-content">
          <span>{{ item.title }}</span>
          <span
            v-if="item.badge"
            class="menu-badge"
            :class="item.badgeType"
          >{{ badgeValue(item.badge) }}</span>
        </span>
      </el-menu-item>

      <el-submenu index="settings">
        <template slot="title">
          <i class="el-icon-setting" />
          <span>系统设置</span>
        </template>
        <el-menu-item index="/settings/address">
          <span class="submenu-dot" />
          <span>收件地址管理</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>

    <div class="sidebar-tip">
      <div class="tip-title">
        <span class="tip-dot" />
        在线接待中
      </div>
      <p class="tip-text">
        咨询池用于抢接新咨询；抢单后进入“我的会话”，在聊天里推进报价、下单和订单处理。
      </p>
    </div>
  </aside>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppSidebar',
  data() {
    return {
      menuItems: [
        { path: '/consult-pool', title: '咨询池', icon: 'el-icon-document-checked', badge: 'consultPool', badgeType: 'danger' },
        { path: '/sessions', title: '我的会话', icon: 'el-icon-chat-dot-round', badge: 'sessions', badgeType: 'primary' },
        { path: '/order-pool', title: '订单池', icon: 'el-icon-s-order' },
        { path: '/dispatch', title: '派单管理', svg: 'swap', badge: 'dispatch', badgeType: 'warning' },
        { path: '/field', title: '外勤管理', svg: 'worker' }
      ]
    }
  },
  computed: {
    ...mapState(['badges']),
    activeMenu() {
      const path = this.$route.path
      if (path.startsWith('/settings')) {
        return path
      }
      return path
    },
    openedMenus() {
      return this.$route.path.startsWith('/settings') ? ['settings'] : ['settings']
    }
  },
  methods: {
    badgeValue(key) {
      return this.badges[key] || 0
    }
  }
}
</script>

<style scoped>
.app-sidebar {
  display: flex;
  flex-direction: column;
  width: 220px;
  height: 100%;
  background: #fff;
  border-right: 1px solid #eef2f5;
  box-sizing: border-box;
  padding: 20px 14px 16px;
}

.sidebar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 6px 18px;
}

.logo {
  flex-shrink: 0;
  line-height: 0;
}

.brand-name {
  font-size: 20px;
  font-weight: 700;
  color: #1f2329;
  line-height: 1.2;
}

.brand-tag {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e8f7f4;
  color: #2aa89a;
  font-size: 12px;
  line-height: 1.5;
}

.sidebar-menu {
  flex: 1;
  border-right: none;
  background: transparent;
  overflow-y: auto;
}

.sidebar-menu >>> .el-menu-item,
.sidebar-menu >>> .el-submenu__title {
  height: 44px;
  line-height: 44px;
  margin-bottom: 4px;
  border-radius: 12px;
  color: #4e5969;
  padding: 0 12px !important;
}

.menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  margin-right: 8px;
  vertical-align: middle;
  color: #86909c;
}

.sidebar-menu >>> .el-menu-item.is-active .menu-icon {
  color: #1f9e8f;
}

.sidebar-menu >>> .el-menu-item i,
.sidebar-menu >>> .el-submenu__title i {
  color: #86909c;
  font-size: 16px;
  width: 18px;
  margin: 0;
  text-align: center;
}

.worker-icon,
.swap-icon {
  display: block;
}

.sidebar-menu >>> .el-menu-item:hover,
.sidebar-menu >>> .el-submenu__title:hover {
  background: #f5f8fa;
}

.sidebar-menu >>> .el-menu-item.is-active {
  background: #e8f7f4;
  color: #1f9e8f;
  border: 1px solid #1f2329;
  box-sizing: border-box;
  height: 44px;
  line-height: 42px;
}

.sidebar-menu >>> .el-menu-item.is-active i {
  color: #1f9e8f;
}

.menu-item-content {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 28px);
  vertical-align: top;
}

.menu-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
}

.menu-badge.danger {
  background: #f56c6c;
}

.menu-badge.primary {
  background: #2aa89a;
}

.menu-badge.warning {
  background: #f59e0b;
}

.sidebar-menu >>> .el-submenu .el-menu-item {
  min-width: auto;
  padding-left: 38px !important;
  height: 40px;
  line-height: 40px;
  color: #4e5969;
}

.sidebar-menu >>> .el-submenu .el-menu-item.is-active {
  background: #e8f7f4;
  color: #1f9e8f;
  border: 1px solid #1f2329;
  line-height: 38px;
}

.submenu-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-right: 8px;
  border-radius: 50%;
  background: #c0c4cc;
  vertical-align: middle;
}

.sidebar-menu >>> .el-submenu__icon-arrow {
  display: none;
}

.sidebar-tip {
  margin-top: 12px;
  padding: 14px 12px;
  border-radius: 12px;
  background: #f3f8f7;
}

.tip-title {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1f9e8f;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

.tip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1f9e8f;
}

.tip-text {
  margin: 0;
  color: #86909c;
  font-size: 12px;
  line-height: 1.6;
}
</style>
